import Skeleton, { type SkeletonProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

//https://github.com/dvtng/react-loading-skeleton

const LoadingSkeleton: React.FC<SkeletonProps> = ({ borderRadius = 6, baseColor = '#eaeaea', ...props }) => {
  return <Skeleton {...props} borderRadius={borderRadius} baseColor={baseColor} />;
};

export default LoadingSkeleton;
